import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./my-site-welcome.html";

const STYLE_OVERRIDE = "border-radius: 50%;";
export class MySiteWelcome extends PolymerElement {
    static get template() {
        let htmlElement = document.createElement("TEMPLATE");
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return "my-site-welcome";
    }

    static get properties() {
        return {
            _photoUrl: {
                type: String,
                observer: "_handlePhoto"
            },
            _storeName: {
                string: String,
                value: ""
            },
            _storeDescription: {
                type: String,
                value: ""
            }
        };
    }

    ready() {
        super.ready();
    }

    _handlePhoto(newVal) {
        if (newVal.indexOf("logo.png") !== -1)
            this.set("styleOverride", STYLE_OVERRIDE);
        else
            this.set(
                "styleOverride",
                STYLE_OVERRIDE + "border: 1px solid #272525; background-color: #272525"
            );
    }

}

window.customElements.define(MySiteWelcome.is, MySiteWelcome);
